import { render, staticRenderFns } from "./EditExport.vue?vue&type=template&id=70aabcfc&scoped=true&"
import script from "./EditExport.vue?vue&type=script&lang=js&"
export * from "./EditExport.vue?vue&type=script&lang=js&"
import style0 from "./EditExport.vue?vue&type=style&index=0&id=70aabcfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aabcfc",
  null
  
)

export default component.exports